document.addEventListener('alpine:init', () => {
  Alpine.data('VariantSelect', () => ({
    mounted() {
      let am = this;

      let $product = am.$el.closest('.product');
      let $btn_atc = $product.querySelector('.single-add-to-cart-button');

      am.$el.addEventListener('change', (e) => {
        // console.log(e);
        am.$nextTick(() => {
          $product.classList.add('size-selected');

          e.target.querySelectorAll('option').forEach(($option) => {
            let is_selectedOption = $option.value == e.target.value;
            if (is_selectedOption) {
              $product.classList.toggle('is-soldout', $option.disabled);
              $product.classList.toggle('is-available', !$option.disabled);

              $btn_atc.disabled = $option.disabled;
              $btn_atc.textContent = $option.disabled ? 'Sold out' : 'Add to cart';
            }

            // allow options to be selected for klaviyo
            $option.disabled = false;
          });
        })
      });
    }
  }));
});